import React, { useState, useEffect } from 'react';
import { Icon, Menu, Table } from 'semantic-ui-react'; // You may need to install: npm install semantic-ui-react

const DataTable = ({ data, headers, currentPage = 1, displayTotal = false, totalLink = false, onSelected, onAllSelected }) => {
  const [sortKey, setSortKey] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [perPage] = useState(20);
  const [page, setPage] = useState(currentPage);

  useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);

  const sortData = (key) => {
    setSortKey(key);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  };

  const sortedData = () => {
    if (!data || data.length === 0 || sortKey === '') return data;

    return data.sort((a, b) => {

      if (a[sortKey] === null || a[sortKey] === undefined) {
        return 1;
      }
      if (b[sortKey] === null || b[sortKey] === undefined) {
        return -1;
      }

      if (isNaN(a[sortKey])) {
        return sortDirection === 'asc'
          ? a[sortKey].localeCompare(b[sortKey])
          : b[sortKey].localeCompare(a[sortKey]);
      } else {
        return sortDirection === 'asc' ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey];
      }
    });
  };

  const paginatedData = () => {
    return sortedData().slice((page - 1) * perPage, page * perPage);
  };

  const getTotal = (key, header) => {
    if (header.type === 'number' || header.type === 'money') {
      const total = data.reduce((sum, item) => sum + item[key], 0);
      return displayField(total, header);
    } else if (header.type === 'string' && header.name === 'Name') {
      return totalLink ? 'All Courses' : 'Total';
    }
    return '';
  };

  const displayField = (item, header) => {
    if (item === null || item === undefined) {
      return '';
    }
    // return header.type
    if (header.type === 'money') {
      return `£${(+item).toFixed(2)}`;
    } else if (header.type === 'number') {
      return item?.toLocaleString();
    } else if (header.type === 'date') {
      return item.split(' ')[0].split('-').reverse().join('/');
    } else if (header.type === 'datetime') {
      const datePart = item.split(' ')[0].split('-').reverse().join('/');
      const timePart = item.split(' ')[1];
      return `${datePart} ${timePart.split('.')[0]}`;
    } else if (header.type === 'string' && (item == "0" || item == "1")) {
      return item == "1" ? "Yes" : "No";
    }
    return item;
  };

  const maxPages = Math.ceil(data.length / perPage);

  const goToPage = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= maxPages) {
      setPage(pageNumber);
    }
  };

  return (
    <>
      <Table celled padded striped>
        <Table.Header>
          <Table.Row>
            {Object.keys(headers).map((key) => (
              <Table.HeaderCell key={key} onClick={() => sortData(key)}>
                {headers[key].name}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {paginatedData().map((item, datakey) => (
            <Table.Row key={`row-${datakey}`}>
              {Object.keys(headers).map((key) => (
                <Table.Cell key={`content-${key}-${datakey}`}>
                  {/* {JSON.stringify(item)} */}
                  {headers[key].clickable ? (
                    <a href="#" onClick={(e) => { e.preventDefault(); onSelected(item); }}>
                      {displayField(item[key], headers[key])}
                    </a>
                  ) : (
                    <span>{displayField(item[key], headers[key])}</span>
                  )}
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
        {(maxPages > 1 || displayTotal) && (
          <Table.Footer>
            {displayTotal && data.length > 0 && (
              <Table.Row>
                {Object.keys(headers).map((key) => (
                  <Table.Cell key={`total-${key}`}>
                    <strong>
                      {headers[key].name === 'Name' && totalLink ? (
                        <a href="#" onClick={(e) => { e.preventDefault(); onAllSelected(); }}>
                          {getTotal(key, headers[key])}
                        </a>
                      ) : (
                        getTotal(key, headers[key])
                      )}
                    </strong>
                  </Table.Cell>
                ))}
              </Table.Row>
            )}
            {maxPages > 1 && (
              <Table.Row>
                <Table.HeaderCell colSpan={Object.keys(headers).length}>
                  <Menu pagination>
                    <Menu.Item
                      as="a"
                      icon
                      disabled={page === 1}
                      onClick={() => goToPage(page - 1)}
                    >
                      <Icon name="left chevron" />
                    </Menu.Item>
                    {Array.from({ length: maxPages }, (_, index) => (
                      <Menu.Item
                        as="a"
                        key={index + 1}
                        active={index + 1 === page}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </Menu.Item>
                    ))}
                    <Menu.Item
                      as="a"
                      icon
                      disabled={page === maxPages}
                      onClick={() => goToPage(page + 1)}
                    >
                      <Icon name="right chevron" />
                    </Menu.Item>
                  </Menu>
                </Table.HeaderCell>
              </Table.Row>
            )}
          </Table.Footer>
        )}
      </Table>
    </>
  );
};

export default DataTable;
